export default "__VITE_ASSET__P0Yyk0C7__"